import { Singleton } from 'framework/di';

import { JQueryHelper } from './jquery.helper';

@Singleton()
export class SlickHelper {
  loaded: boolean = false;

  constructor(protected jqueryHelper: JQueryHelper) {
    this.load();
  }

  get jQuery(): JQueryStatic {
    return this.jqueryHelper.jQuery;
  }

  async load(): Promise<boolean> {
    if (!this.loaded) {
      await this.jqueryHelper.load();
      // eslint-disable-next-line
      // @ts-ignore: TS2306 error
      await import('slick-carousel');
      this.loaded = true;

      return Promise.resolve(true);
    }

    return Promise.resolve(true);
  }

  onLoaded(callback: () => void) {
    if (this.loaded) {
      callback();
    } else {
      this.load().then(() => {
        callback();
      });
    }
  }
}
